module.exports = __webpack_public_path__ + "static/img/foldup-aside.2992c47f.svg";